import React from 'react';

const Landing : React.FC = () => {
    return (
        <>
            Landing
        </>
    )
}

export default Landing;